import {createSlice} from '@reduxjs/toolkit';

const cartSlice = createSlice({
    name: 'cart',
    initialState: {
        items: [],
    },
    reducers: {
        addItem: (state, action) => {
            const product = action.payload;


            const isDigital =
                product.category && product.category.toLowerCase() === 'digital';

            const quantity = isDigital ? 1 : (product.quantity ?? 1);

            const key = product.selectedVariant
                ? product.selectedVariant.sku
                : product.sku;

            const existingItem = state.items.find(
                (item) => item._id === product._id && item.sku === key
            );

            const stock = product.selectedVariant
                ? product.selectedVariant.stock ?? product.selectedVariant.quantity
                : product.stock;

            if (existingItem) {
                if (isDigital) {
                    existingItem.quantity = 1;
                } else if (stock && existingItem.quantity < stock) {
                    existingItem.quantity += quantity;
                } else if (!stock) {
                    existingItem.quantity += quantity;
                }
            } else {
                state.items.push({
                    ...product,
                    sku: key,
                    quantity,
                });
            }
        },

        removeItem: (state, action) => {
            const {id, sku} = action.payload;
            state.items = state.items.filter(
                (item) => !(item._id === id && item.sku === sku)
            );
        },

        clearCart: (state) => {
            state.items = [];
        },

        updateQuantity: (state, action) => {
            const {id, sku, quantity, stock, isDigital} = action.payload;
            const item = state.items.find((item) => item._id === id && item.sku === sku);

            if (item) {
                if (isDigital) {
                    item.quantity = 1;
                } else {
                    item.quantity = Math.min(quantity, stock ? stock : 50);
                }
            }
        },
        setItemPromotions: (state, action) => {
            const {sku, promotions} = action.payload;

            state.items = state.items.map(item =>
                item.sku === sku
                    ? {...item, promotions}
                    : item
            );
        },
        setBulkItemPromotions: (state, action) => {
            action.payload.forEach(({sku, promotions}) => {
                state.items
                    .filter(item => item.sku === sku)
                    .forEach(item => {
                        item.promotions = promotions;
                    });
            });
        }
    },
});

export const {addItem, removeItem, clearCart, updateQuantity, setItemPromotions, setBulkItemPromotions} =
    cartSlice.actions;
export default cartSlice.reducer;
